import { inject } from 'vue'
export const useRefresh = () => {
  const mitter = inject('mitter') as any
  const refreshTable = () => {
    mitter.emit('TABLE_REFRESH')
  }
  return {
    refreshTable
  }
}
